import { superagent } from '../../shared/superagent/superagent';
import singletons from '../../shared/singletons'
import { Observable } from 'rxjs'

class LoginApi {
  sendCode(phone) {
    singletons['loading'].start()
    return Observable.create((obs)=> {
      superagent.post("/api/send_code")
        .send({phone: phone})
        .end((err, resp)=> {
          singletons['loading'].stop()
          obs.next(resp.body)
          obs.complete()
        })
    })
  }

  refreshCode(phone) {
    singletons['loading'].start()
    return Observable.create((obs)=> {
      superagent.post("/api/resend_code")
        .send({phone: phone})
        .end((err, resp)=> {
          singletons['loading'].stop()
          obs.next(resp.body)
          obs.complete()
        })
    })
  }

  emailLogin(email, password) {
    singletons['loading'].start()
    return Observable.create((obs)=> {
      superagent.post("/api/login_by_email")
        .send({email: email, password: password})
        .end((err, resp)=> {
          singletons['loading'].stop()
          obs.next(resp.body)
          obs.complete()
        })
    })
  }

  emailRecovery(email) {
    singletons['loading'].start()
    return Observable.create((obs)=> {
      superagent.post("/api/recovery")
        .send({email: email})
        .end((err, resp)=> {
          singletons['loading'].stop()
          obs.next(resp.body)
          obs.complete()
        })
    })
  }

  registerEmail(h) {
    singletons['loading'].start()
    return Observable.create((obs)=> {
      superagent.post("/api/register")
        .send({user: h})
        .end((err, resp)=> {
          singletons['loading'].stop()
          obs.next(resp.body)
          obs.complete()
        })
    })
  }

  askRing(phone) {
    singletons['loading'].start()
    return Observable.create((obs)=> {
      superagent.post("/api/ask_ring")
        .send({phone: phone})
        .end((err, resp)=> {
          singletons['loading'].stop()
          obs.next(resp.body)
          obs.complete()
        })
    })
  }

  askPhoneNumberForCall(phone) {
    singletons['loading'].start()
    return Observable.create((obs)=> {
      superagent.post("/api/ask_phone_number_for_call")
        .send({phone: phone})
        .end((err, resp)=> {
          singletons['loading'].stop()
          obs.next(resp.body)
          obs.complete()
        })
    })
  }

  checkPhoneLogined() {
    return Observable.create((obs)=> {
      superagent.post("/api/check_phone_logined")
        .end((err, resp)=> {
          obs.next(resp.body)
          obs.complete()
        })
    })
  }
}

const loginApi = new LoginApi()


export { loginApi }



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/profile/login/login_api.js